import { getKeys } from '../../adapters/utils';
import { SD_STATUS } from '../../consts';
export var IDs = {
    SD_JSON_RENDER: 'breadcrumb-component.structured-data.render',
};
var SchemaTypes = {
    BREADCRUMBS_COMPONENT_ITEM_LIST: 'breadcrumbs-component-item-list-preset',
};
var userVisible = [];
var getStructuredData = function (item) {
    var items = Array.isArray(item === null || item === void 0 ? void 0 : item.items) ? item.items : [];
    if (!items.length) {
        return {
            '@context': 'https://schema.org',
        };
    }
    var validItems = items.filter(function (breadcrumbItem) {
        return breadcrumbItem &&
            typeof breadcrumbItem === 'object' &&
            breadcrumbItem.name &&
            breadcrumbItem.item;
    });
    if (!validItems.length) {
        return {
            '@context': 'https://schema.org',
        };
    }
    return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: validItems.map(function (breadcrumbItem, index) { return ({
            '@type': 'ListItem',
            position: index + 1,
            name: breadcrumbItem.name,
            item: breadcrumbItem.item,
        }); }),
    };
};
export default {
    IDs: IDs,
    SchemaTypes: SchemaTypes,
    getData: function (item) {
        var _a;
        return _a = {},
            _a[IDs.SD_JSON_RENDER] = getStructuredData(item),
            _a;
    },
    getSdStatus: function () { return SD_STATUS.ENABLED; },
    getKeys: function () { return getKeys(IDs, userVisible); },
    getSdKeys: function () { return []; },
};
